import { MemoryRouter } from "react-router-dom";

import { Header } from "../Header";
import { Router } from "../Router";
import { Providers } from "./Providers";
import { Content, Wrapper } from "./styles";

export const App = () => {
  return (
    <MemoryRouter>
      <Wrapper>
        <Providers>
          <Header />
          <Content>
            <Router />
          </Content>
        </Providers>
      </Wrapper>
    </MemoryRouter>
  );
};
